import { resetAuthExpiryHandling, tryBeginAuthExpiryHandling } from '@glyphic/shared-core'
import type { NavigateFunction } from 'react-router-dom'

import type { ToastShowOptions } from '../context/ToastContext'
import { type ErrorInterceptorContext,registerErrorInterceptor } from './client'
import { isUnauthorizedApiError,markApiErrorAuthHandled } from './errors'

type AuthSessionBridge = {
  showToast: (options: ToastShowOptions) => void
  navigate: NavigateFunction
  clearState: () => void
}

let bridge: AuthSessionBridge | null = null
let interceptorsInstalled = false

export function registerAuthSessionBridge(next: AuthSessionBridge): void {
  bridge = next
  /** Provider 刚挂载：释放此前因 bridge 未就绪而未能跳转的 401 闸门 */
  resetAuthExpiryHandling()
}

export function ensureAuthInterceptors(): void {
  if (interceptorsInstalled) return
  interceptorsInstalled = true
  registerErrorInterceptor(handleAuthExpiryError)
}

/** 供未走 apiRequest 的 fetch 旁路在检测到 401 时调用 */
export function notifyApiSessionExpired(): void {
  endSessionAndRedirectToLogin('登录已失效，请重新登录')
}

/** 会话校验时后端不可达：清除本地登录态并回到登录页 */
export function notifyBackendUnavailable(): void {
  endSessionAndRedirectToLogin('无法连接服务器，请确认后端已启动')
}

function endSessionAndRedirectToLogin(toastMessage: string): void {
  if (!bridge) {
    /** 拦截器已注册但 AuthSessionProvider 尚未 effect：勿占用 tryBeginAuthExpiryHandling */
    return
  }
  if (!tryBeginAuthExpiryHandling()) return
  bridge.clearState()
  bridge.showToast({
    message: toastMessage,
    variant: 'warning',
    autoCloseMs: 4000,
  })
  const path = window.location.pathname
  if (path !== '/login' && !path.startsWith('/login/')) {
    bridge.navigate('/login', {
      replace: true,
      state: { from: { pathname: path + window.location.search } },
    })
  }
}

function handleAuthExpiryError(ctx: ErrorInterceptorContext): void {
  const { error } = ctx
  if (!isUnauthorizedApiError(error)) return
  markApiErrorAuthHandled(error)
  notifyApiSessionExpired()
}

/** 模块加载即注册，避免子 Provider 的首个请求早于 AuthSessionProvider 的 effect */
ensureAuthInterceptors()
